<template>
  <v-container fluid>
    <v-form v-model="valid">
      <v-layout class="mt-3">
        <v-flex xs6>
          <span class="title -tongue ml-5">Deseja fazer a Licença Ambiental por Compromisso?</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-radio-group
              :rules="[validationRules.notNull]" v-model="applicationSimplified.simplified">
            <v-radio
                label="Sim"
                :value="true"
            ></v-radio>
            <v-radio
                label="Não"
                :value="false"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-divider class="mt-3 pb-6"/>
      <template v-if="applicationSimplified.simplified">
        <div class="title -tongue ml-5 mb-5 mt-5">Questionário de Qualificação (Autodeclaratório)</div>

        <div>
        <v-layout column class="mb-2" v-for="question in applicationSimplified.qualificacao">
          <h3 class="title mb-0">
            {{ question.question }}
          </h3>
          <v-flex xs3>
            <v-radio-group row
                           v-model="question.answer"
                           :rules="[validationRules.notNull]"
                           @change="handleAnswerChange(question)"
            >
              <v-radio label="Não" :value="false"/>
              <v-radio label="Sim" :value="true"/>
              <template v-if="question.answer !== null && question.answerTemplate === false && question.answer === true && !question.group">
                <span class="wrong text-md-center">
                  Atenção: Não se qualifica para LAC
                </span>
              </template>
            </v-radio-group>
          </v-flex>
        </v-layout>
        </div>

        <v-alert outline color="error" icon="mdi-alert" :value="showNotQualify" class="text-md-center mt-3">
          O seu requerimento não se aplica ao Licenciamento Ambiental por Compromisso, por isso será necessário
          realizar o Licenciamento Ambiental Ordinário
        </v-alert>

          <v-divider class="mt-3 mb-3"/>
      </template>
      <v-layout>
        <v-flex xs6>
          <v-layout justify-space-between>
            <v-btn flat @click="previousStep()">Voltar</v-btn>
            <v-btn
                :disabled="!valid"
                @click="mountStep()"
                color="primary"
            >
              Continuar
              <v-icon right>mdi-arrow-right mdi-18px</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import validationRules from '@/mixins/validation-rules';
  import { mapActions } from 'vuex';
  import {qualificacaoLacArray} from "@/utils/lac";

  export default {
    name: 'ApplicationWay',
    mixins: [validationRules],
    async beforeMount() {
      this.applicationSimplified.qualificacao = qualificacaoLacArray.map(
        (question) => {
          return {
            ...question,
            answer: null
          }
        }
      );
    },
    data() {
      return {
        valid: false,
        validationRules,
        showNotQualify: false,
        applicationSimplified: { simplified: null, qualify: false, qualificacao: [] }
      };
    },
    methods: {
      ...mapActions('newApplication', ['setApplicationSimplified', 'nextStep', 'previousStep', 'setValidSteps']),

      mountStep() {
        this.setApplicationSimplified(this.applicationSimplified);
        this.nextStep()
      },
      
      handleAnswerChange(question) {
        // Se a pergunta faz parte do grupo de zonas e a resposta é verdadeira
        if (question.group === 'zona' && question.answer === true) {
          // Define todas as outras perguntas do grupo como falsas
          this.applicationSimplified.qualificacao.forEach(q => {
            if (q.group === 'zona' && q !== question) {
              q.answer = false;
            }
          });
        }
      },
    },
    watch: {
      'applicationSimplified.qualificacao': {
        handler() {
          // Verificar se pelo menos uma opção de cada grupo está marcada como true
          const groupedQuestions = {};
          this.applicationSimplified.qualificacao.forEach(question => {
            if (question.group) {
              if (!groupedQuestions[question.group]) {
                groupedQuestions[question.group] = [];
              }
              groupedQuestions[question.group].push(question);
            }
          });
          
          // Para cada grupo, verificar se pelo menos uma opção está como true
          const groupsValid = Object.keys(groupedQuestions).every(group => {
            return groupedQuestions[group].some(question => question.answer === true);
          });
          
          // Verificar as perguntas individuais (sem grupo)
          const individualQuestionsValid = this.applicationSimplified.qualificacao
            .filter(question => !question.group)
            .every(question => question.answer !== null && (question.answerTemplate === true || question.answer === false));
          
          const allAnswered = this.applicationSimplified.qualificacao.every(
              (question) => question.answer !== null
          );
          
          const qualify = individualQuestionsValid && groupsValid;

          if(this.applicationSimplified.simplified) {
            if(allAnswered && qualify) {
              this.applicationSimplified.qualify = true;
              this.showNotQualify = false;
            } else if (allAnswered && !qualify) {
              this.applicationSimplified.qualify = false;
              this.showNotQualify = true;
            } else {
              this.applicationSimplified.qualify = false;
              this.showNotQualify = false;
            }
          } else {
            this.applicationSimplified.qualify = false;
          }
        },
        deep: true
      },
      valid() {
        console.log(this.valid)
        this.setValidSteps(this.valid);
      },
    }
  };
</script>

<style>
.wrong {
  color: red;
}
</style>